<script setup>
import { useRouter } from 'vue-router'

const { locale, locales } = useI18n()
const switchLocalePath = useSwitchLocalePath()
const router = useRouter()

const availableLocales = computed(() => {
  return locales.value
})

function handleLocaleChange(newLocale) {
  const path = switchLocalePath(newLocale)
  if (path)
    router.push(path)

  document.documentElement.lang = newLocale
}

onMounted(() => {
  document.documentElement.lang = locale.value
})
</script>

<template>
  <div class="language-selection">
    <select
      v-model="locale"
      class="language-selection__select"
      aria-label="Select language"
      @change="handleLocaleChange($event.target.value)"
    >
      <option
        v-for="loc in availableLocales"
        :key="loc.code"
        :value="loc.code"
      >
        {{ loc.name }}
      </option>
    </select>
  </div>
</template>

<style lang="scss" scoped>
.language-selection {
  position: relative;
  display: flex;
  justify-content: center;

  &__select {
    display: flex;
    align-items: center;
    color: rgb(50 50 50);
    background-color: rgb(0 0 0 / 5%) !important;

    // width: 100%;
    border: 1px solid rgb(0 0 0 / 10%);
    border-radius: 25px;
    padding: 0.5rem;
    appearance: none;
    background-image: url('/icon-i18.svg'), url('/carrot.svg');
    background-position: left 0.5rem center, right 0.5rem center;
    background-repeat: no-repeat;
    background-size: 20px, auto;
    padding-left: 2.5rem;
    padding-right: 2rem;
    font-size: 1.1rem;
  }
}
</style>

<!-- <script setup>
const { locale, locales } = useI18n()
const switchLocalePath = useSwitchLocalePath()

const isOpen = ref(false) // State for open/close

const currentSelection = computed(() => {
  return locales.value.find(i => i.code === locale.value)
})

const availableLocales = computed(() => {
  return locales.value.filter(i => i.code !== locale.value)
})

function toggleMenu() {
  isOpen.value = !isOpen.value
}
</script>

<template>
  <div class="language-selection" @keydown.esc="isOpen = false">
    <button
      class="language-selection__current-selection"
      aria-haspopup="true"
      aria-expanded="isOpen"
      @click="toggleMenu"
    >
      <img src="/icon-i18.svg" alt="">
      select language{{ currentSelection }}
      <img class="carrot" src="/carrot.svg" alt="">
    </button>

    <div
      v-show="isOpen"
      class="language-selection__options"
      role="menu"
      aria-labelledby="language-menu-button"
    >
      <NuxtLink v-for="locale in availableLocales" :key="locale.code" :to="switchLocalePath(locale)">
        {{ locale }}
      </NuxtLink>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.language-selection {
  position: relative;
  display: flex;
  justify-content: center;

  &__current-selection {
    // position: absolute;
    // top: 0;
    // right: 0;
    display: flex;
    align-items: center;
    color: rgb(50 50 50);
    background-color: rgb(0 0 0 / 8.1%) !important;
    width: 100%;

    // height:;
    border: 1px solid rgb(0 0 0 / 10%);
    padding-right: 0.5rem;

    img {
      width: 20px;
      height: 20px;
      margin-right: 0.5rem;

      &.carrot {
        width: auto;
        height: auto;
        margin-left: 0.75rem;
        transform: translate3d(0, 1px, 0) rotate(0deg);
      }
    }
  }

  &__options {
    position: absolute;
    z-index: 10;
    background-color: white;
    margin: 0;
    padding: 1rem;
    min-width: 7rem;
    border-radius: 5px;
    top: 3rem;
    right: 0;
    display: flex;
    flex-direction: column;

    a {
      color: black;
      text-decoration: none;
    }
  }
}
</style> -->
